import Character1 from './img/driver1.svg';
import Character2 from './img/driver2.svg';



export const drivers = [Character1, Character2];
export const MAX_RATE = 5;

export const RESULT_TEXTS = [
    `На жаль, ви змогли отримати «п'ятірку» від пасажира <b>жодного разу</b>. Не зупиняйтесь, спробуйте ще! Ви були б гарним драйвером в <b>Uklon Driver</b>.`,
    `На жаль, ви змогли отримати «п'ятірку» від пасажира лише <b>один</b> раз. Не зупиняйтесь, спробуйте ще! Ви були б гарним драйвером в <b>Uklon Driver</b>.`,
    `На жаль, ви змогли отримати «п'ятірку» від пасажира лише <b>два</b> рази. Не зупиняйтесь, спробуйте ще! Ви були б гарним драйвером в <b>Uklon Driver</b>.`,
    `Вітаємо! Вам вдалося <b>тричі</b> отримати від пасажирів «п'ятірки». З таким підходом до роботи ви б стали драйвером місяця в <b>Uklon Driver</b>.`,
    `Вітаємо! Вам вдалося отримати від пасажирів «п'ятірки» <b>чотири</b> рази!. З таким підходом до роботи ви б стали драйвером місяця в <b>Uklon Driver</b>.`,
    `Вітаємо! Вам вдалося отримати від пасажирів «п'ятірки» <b>п'ять</b> разів!.З таким підходом до роботи ви б стали драйвером місяця в <b>Uklon Driver</b>.`,
    `Вітаємо! Вам вдалося отримати від пасажирів «п'ятірки» в <b>кожній</b> сітуації. Ви - справжній водій Uklon!`,
]